/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// Create a new store
const store = new Vuex.Store({
	state: {
		status: '',
		applicant: JSON.parse(localStorage.getItem('data')) || {},
		access: localStorage.getItem('access') || ''
	},

	mutations: {
		guardError(state) {
			state.applicant = {};
			state.status = 'error';
		},

		setApplicant(state, applicant) {
			state.applicant = JSON.parse(applicant);
			state.status = 'success';
		},

		setAccess(state, access) {
			state.access = access;
		},

		setFinish(state) {
			state.applicant = {};
			state.access = '';
			state.status = '';
		}
	},

	actions: {
		setApplicant(context, payload) {
			return new Promise((resolve, reject) => {
				axios
					.post('/applicants', payload)
					.then((response) => {
						let data = response.data.data;

						context.commit('setApplicant', JSON.stringify(data));
						localStorage.setItem('data', JSON.stringify(data));

						resolve(response);
					})
					.catch((error) => {
						localStorage.removeItem('data');
						context.commit('guardError');
						console.log(error);
						reject(error);
					});
			});
		},

		setAccess(context, payload) {
			return new Promise((resolve, reject) => {
				axios
					.post('/get-tokenTest', payload)
					.then((response) => {
						let data = response.data;

						context.commit('setAccess', data);
						localStorage.setItem('access', data);

						resolve(response);
					})
					.catch((error) => {
						localStorage.removeItem('access');
						console.log(error);
						reject(error);
					});
			});
		},

		setFinish(context, payload) {
			if (context.getters.isGuardHome) {
				return new Promise((resolve, reject) => {
					axios
						.post('/postResult', payload)
						.then((response) => {
							context.commit('setFinish');
							localStorage.removeItem('data');
							resolve(response);
						})
						.catch((error) => {
							console.log(error);
							reject(error);
						});
				});
			}
		}
	},

	getters: {
		authStatus: (state) => state.status,
		applicant: (state) => state.applicant,
		access: (state) => state.access,
		isGuardHome: (state) => Object.keys(state.applicant).length !== 0
	}
});

export default store;